/* Sanitizes a string to be used as (part of) a url.

    - makes it lowercase
    - removes diacritics
    - replaces non-valid characters with a dash
    - reduces groups of consecutive dashes to a single dash

    Examples:

    - Crème Brûlée        => creme-brulee
    - Tab\\$%^@$^&^&(*)(( => tab-
    - Halloween🎃         => halloween-
    - The  tab 2          => the-tab-2
 */

export const sanitizeString = (aString) =>
  aString
    .normalize('NFD') // convert to unicode normal form
    .replace(/[\u0300-\u036f]/g, '') // remove everything in U+0300 → U+036F range
    .replace(/[^a-z0-9]/gi, '-') // remove non-valids
    .replace(/^-+|-+(?=-)/g, '') // replace repeated occurrences of dash with single dash
    .toLowerCase();
